import React, { useContext, useEffect, useState } from "react";
import "./Navbar.css";
import { FaChevronDown, FaChevronRight, FaSearch } from "react-icons/fa";
import { LanguageContext } from "../../store/language-context";
import useResources from "../../admin/Components/Dashboard/Resources/useResources";
import axios from "axios";
import Swal from "sweetalert2";
import { FaRegFilePdf } from "react-icons/fa";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GrLanguage } from "react-icons/gr";

const Navbar = ({ Ip, handleOpenPage }) => {
  const { divLists, setDivLists } = useResources(Ip);
  const [logoAr, setLogoAr] = useState("");
  const [logoEn, setLogoEn] = useState("");
  const [searchText, setSearchText] = useState("");
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [navbarColor, setNavbarColor] = useState("");
  const [isVideo, setIsVideo] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const logoArr = logoAr;
  const correctedArPath = logoArr ? logoArr.replace("../assets", "assets") : "";
  const logoArPath = `${Ip}${correctedArPath}`;

  const logoEnn = logoEn;
  const correctedEnPath = logoEnn ? logoEnn.replace("../assets", "assets") : "";
  const logoEnPath = `${Ip}${correctedEnPath}`;

  const { isLang, changeLang } = useContext(LanguageContext);

  useEffect(() => {
    if (location.pathname === "/") {
      setNavbarColor("#ffffff45");
    } else {
      setNavbarColor("#fff");
    }
  }, [location.pathname]);

  // function handleDownload(type) {
  //   const fileUrl =
  //     type === "bio"
  //       ? "/pdf/Raed H. Charafeddine - English Bio.pdf"
  //       : type === "shortbio"
  //       ? "/pdf/Raed H. Charafeddine - Short Bio - English.pdf"
  //       : type === "bioar"
  //       ? "/pdf/رائد شرف الدين - السيرة الذاتية.pdf"
  //       : type === "shortbioar"
  //       ? "/pdf/رائد شرف الدين - السيرة الذاتية-مختصر.pdf"
  //       : "";
  //   const link = document.createElement("a");
  //   link.href = fileUrl;
  //   link.download = fileUrl.split("/").pop();
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   // setMenuOpen(false);
  // }

  function handleDownload(type) {
    window.open(
      `${Ip}controllers/pdf.php?action=downloadPdf&category=${type}`,
      "_blank",
    );
  }
  const handleSearch = async () => {
    if (!searchText.trim()) {
      Swal.fire("Error", "Please enter a search term.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("Action", "search");
    formData.append("text", searchText);
    try {
      const response = await axios.post(
        `${Ip}controllers/search.php`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      const data = response.data;
      setSearchResults(data);
      setShowModal(true);
    } catch (error) {
      console.error("Search error:", error);
      Swal.fire("Error", "Failed to fetch search results.", "error");
    }
  };

  const closeNavbar = () => {
    const collapseEl = document.getElementById("navbarCollapse");
    if (!collapseEl) return;

    const collapseInstance =
      (window.bootstrap &&
        window.bootstrap.Collapse &&
        window.bootstrap.Collapse.getInstance(collapseEl)) ||
      (window.bootstrap && window.bootstrap.Collapse
        ? new window.bootstrap.Collapse(collapseEl, { toggle: false })
        : null);

    if (collapseInstance && collapseInstance.hide) {
      collapseInstance.hide();
    } else {
      collapseEl.classList.remove("show");
    }
  };

  const handleLangChange = () => {
    const newLang = isLang === "En" ? "Ar" : "En";
    changeLang(newLang);

    // Update the lang param in the URL
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("lang", newLang);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const formData = new FormData();
        formData.append("Action", "fetch");
        const response = await axios.post(
          `${Ip}controllers/profile.php`,
          formData,
        );
        // console.log(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [Ip]);

  const fetchProfileData = async () => {
    try {
      const formData = new FormData();
      formData.append("Action", "fetch");
      const response = await axios.post(
        `${Ip}controllers/profile.php`,
        formData,
      );
      if (response.status === 200) {
        const logos = JSON.parse(response.data[0].logo);
        setLogoAr(logos[0].ar);
        setLogoEn(logos[0].en);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, [Ip]);

  const navbarClass = isLang === "AR" ? "navbar-ltr" : "navbar-ltr";
  const logoFirstClass = isLang === "AR" ? "order-1" : "order-1";
  const linksFirstClass = isLang === "AR" ? "order-2" : "order-2";
  const collapseClass = isLang === "AR" ? "" : "";

  return (
    <div
      className={`container-fluid navbar-fixed shadow ${navbarClass}`}
      style={{ backgroundColor: navbarColor }}
    >
      <div className="px-5">
        <nav className="navbar navbar-dark navbar-expand-lg py-0">
          {/* Logo */}
          <div className={`d-flex ${logoFirstClass}`}>
            <Link to="/" className="navbar-brand d-flex flex-column">
              <img src={logoArPath} width="120" alt="Arabic Logo" />
              <img src={logoEnPath} width="120" alt="English Logo" />
            </Link>
          </div>

          {/* Hamburger Icon (Toggler) */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Content */}
          <div
            className={`collapse navbar-collapse ${linksFirstClass} ${collapseClass}`}
            id="navbarCollapse"
          >
            <div className="navbar-nav ms-auto p-0">
              <div
                className="nav-item dropdown"
                style={{ position: "relative" }}
              >
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Why this Website / هدف الموقع <FaChevronDown />
                </Link>
                <div className="dropdown-menu rounded">
                  <Link
                    to="/LearningAsAlmsgiving?lang=En"
                    className="dropdown-item submenu-parent"
                    tabIndex={0}
                    style={{ position: "relative", display: "block" }}
                    onClick={closeNavbar}
                  >
                    Learning as Alms-Giving
                    <div
                      className="nav-item dropdown submenu"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: "100%",
                        display: "none",
                        zIndex: 1050,
                        minWidth: "180px",
                        backgroundColor: "white",
                        borderRadius: "0.25rem",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div
                        onClick={() => handleDownload("learning_en")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        Learning
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/LearningAsAlmsgiving?lang=Ar"
                    className="dropdown-item submenu-parent"
                    tabIndex={0}
                    style={{ position: "relative", display: "block" }}
                    onClick={closeNavbar}
                  >
                    زكاة العلم
                    <div
                      className="nav-item dropdown submenu"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: "100%",
                        display: "none",
                        zIndex: 1050,
                        minWidth: "180px",
                        backgroundColor: "white",
                        borderRadius: "0.25rem",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div
                        onClick={() => handleDownload("learning_ar")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        زكاة العلم
                      </div>
                    </div>
                  </Link>
                </div>
              </div>

              <div className="nav-item dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown" // Add this to enable Bootstrap's dropdown toggle
                  aria-expanded="false" // Add this for accessibility
                >
                  Resources/موارد <FaChevronDown />
                </Link>
                <div className="dropdown-menu dropdown-menu1 rounded">
                  <div className="d-flex flex-column flex-navbar-row p-4">
                    {divLists.map((resource, index) => {
                      let title;
                      if (resource.title === "Governance") {
                        title = "Governance & Human Development";
                      } else {
                        title = resource.title;
                      }
                      return (
                        <div className="col-md-4 col-12" key={index}>
                          <div>
                            <h5 className="text_primary">{title}</h5>
                            <ul className="p-0" style={{ listStyle: "none" }}>
                              {resource.list.map((eco, idx) => {
                                return Number(eco.disabled) === 1 ? (
                                  <div
                                    key={idx}
                                    className="d-flex align-items-center justify-content-start navbar-group"
                                  >
                                    <li>
                                      <Link
                                        to={`/Page?data=${eco.item}&lang=En`}
                                        className="dropdown-item p-1 d-flex gap-1 align-items-center"
                                        onClick={closeNavbar}
                                      >
                                        <FaChevronRight
                                          size={10}
                                          color="rgba(0,0,0,0.6)"
                                        />{" "}
                                        {eco.item} |
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        to={`/Page?data=${eco.item}&lang=Ar`}
                                        className="dropdown-item p-1 d-flex gap-1 align-items-center"
                                        onClick={closeNavbar}
                                      >
                                        {eco.itemAr}
                                      </Link>
                                    </li>
                                  </div>
                                ) : null;
                              })}
                            </ul>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <Link
                to="/VideoGallery"
                className="nav-item nav-link"
                onClick={closeNavbar}
              >
                Video/فيديو
                {/* {isLang === "En" ? "Video Gallery" : "مختارات"} */}
              </Link>

              <div
                className="nav-item dropdown"
                style={{ position: "relative" }}
              >
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Biography/السيرة الذاتية <FaChevronDown />
                </Link>
                <div className="dropdown-menu rounded">
                  <Link
                    to="/Resume?lang=En"
                    className="dropdown-item submenu-parent"
                    tabIndex={0}
                    style={{ position: "relative", display: "block" }}
                    onClick={closeNavbar}
                  >
                    Biography
                    <div
                      className="nav-item dropdown submenu"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: "100%",
                        display: "none",
                        zIndex: 1050,
                        minWidth: "180px",
                        backgroundColor: "white",
                        borderRadius: "0.25rem",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div
                        onClick={() => handleDownload("bio")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        Biography
                      </div>
                      <div
                        onClick={() => handleDownload("shortbio")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        Short Biography
                      </div>
                    </div>
                  </Link>
                  <Link
                    to="/Resume?lang=Ar"
                    className="dropdown-item submenu-parent"
                    tabIndex={0}
                    style={{ position: "relative", display: "block" }}
                  >
                    السيرة الذاتية
                    <div
                      className="nav-item dropdown submenu"
                      style={{
                        position: "absolute",
                        top: 0,
                        right: "100%",
                        display: "none",
                        zIndex: 1050,
                        minWidth: "180px",
                        backgroundColor: "white",
                        borderRadius: "0.25rem",
                        boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                      }}
                    >
                      <div
                        onClick={() => handleDownload("bioar")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        السيرة الذاتية
                      </div>
                      <div
                        onClick={() => handleDownload("shortbioar")}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                      >
                        السيرة الذاتية المختصرة
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* Search Icon and Language Toggle */}
            <div className="icon-search">
              <FaSearch
                onClick={() => setShowSearchInput(!showSearchInput)}
                style={{ cursor: "pointer" }}
              />

              {showSearchInput && (
                <div
                  className="search-container"
                  style={{
                    position: "absolute",
                    padding: "16px",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    borderRadius: "16px",
                    border: "1px solid #ccc",
                  }}
                >
                  <button
                    onClick={() => {
                      setShowSearchInput(false);
                      setShowModal(false);
                    }}
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "transparent",
                      border: "none",
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#333",
                      cursor: "pointer",
                    }}
                  >
                    &times;
                  </button>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      borderBottom: "1px solid #999",
                      paddingBottom: "8px",
                      marginBottom: "16px",
                    }}
                  >
                    <FaSearch style={{ color: "#555", marginRight: "12px" }} />
                    <input
                      type="text"
                      style={{
                        width: "100%",
                        padding: "12px",
                        fontSize: "16px",
                        border: "none",
                        outline: "none",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "12px",
                      }}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                      placeholder="Type to search..."
                      autoFocus
                    />
                  </div>

                  {showModal && (
                    <div
                      className="search-modal"
                      style={{
                        backgroundColor: "#fff",
                        boxShadow: "0 6px 10px rgba(0, 0, 0, 0.15)",
                        borderRadius: "12px",
                        padding: "24px",
                        maxHeight: "60vh",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        position: "relative",
                      }}
                    >
                      <button
                        onClick={() => {
                          setShowModal(false);
                          setShowSearchInput(false);
                        }}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "transparent",
                          border: "none",
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#333",
                          cursor: "pointer",
                        }}
                      >
                        &times;
                      </button>
                      <h5
                        style={{
                          textAlign: "center",
                          fontSize: "20px",
                          fontWeight: "bold",
                          color: "#007BFF",
                          marginBottom: "16px",
                        }}
                      >
                        Search Results
                      </h5>
                      {searchResults.length > 0 ? (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns:
                              "repeat(auto-fill, minmax(200px, 1fr))",
                            gap: "16px",
                          }}
                        >
                          {searchResults.map((result, index) => {
                            const imagePath = result.page.img;
                            const isVideo = imagePath
                              ?.toLowerCase()
                              .endsWith(".mp4");

                            return (
                              <Link
                                to={
                                  result.title
                                    ? `/Page?data=${result.page.title}&lang=${isLang}`
                                    : `/Contact`
                                }
                                key={index}
                                onClick={() => {
                                  setShowModal(false);
                                  setShowSearchInput(false);
                                  setSearchText("");
                                }}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  backgroundColor: "#f5f5f5",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                  transition: "transform 0.3s",
                                  textDecoration: "none",
                                  color: "inherit",
                                }}
                                onMouseEnter={(e) =>
                                  (e.currentTarget.style.transform =
                                    "scale(1.05)")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.transform = "scale(1)")
                                }
                              >
                                {isVideo ? (
                                  <video
                                    src={`${Ip}${imagePath}`}
                                    autoPlay
                                    loop
                                    muted
                                    style={{
                                      width: "100%",
                                      height: "160px",
                                      objectFit: "cover",
                                      borderRadius: "12px",
                                    }}
                                  ></video>
                                ) : (
                                  <img
                                    src={`${Ip}${imagePath}`}
                                    alt="Banner"
                                    style={{
                                      width: "100%",
                                      height: "160px",
                                      objectFit: "cover",
                                      borderRadius: "12px",
                                    }}
                                  />
                                )}

                                <div
                                  style={{
                                    marginTop: "12px",
                                    textAlign: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: "600",
                                      color: "#007BFF",
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: result?.page.title || "",
                                    }}
                                  ></div>
                                </div>

                                {result.title && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginTop: "8px",
                                      color: "#333",
                                    }}
                                  >
                                    <FaRegFilePdf
                                      style={{
                                        color: "#d32f2f",
                                        marginRight: "8px",
                                      }}
                                      size={20}
                                    />
                                    <span>{result.title}</span>
                                  </div>
                                )}
                              </Link>
                            );
                          })}
                        </div>
                      ) : (
                        <p style={{ textAlign: "center", color: "#666" }}>
                          No results found.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className="langSpace"
              onClick={handleLangChange}
              style={{ cursor: "pointer" }}
            >
              {isLang === "En" ? "العربية" : "En"}
              <GrLanguage color="#b6b6b6" size={18} className="mx-2" />
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
